// extracted by css-extract-rspack-plugin
export default {"cls1":"SourcePaperCard-cls1_CKn","cls2":"SourcePaperCard-cls2_9Lr SourcePaperCard-cls1_CKn"};